import { PulseBaseProvider } from '../../base-classes';

const _locationDetailsUri = '/data/locations/v3/closestCity';
const _locationDetailsCacheKey = 'locationDetails';

const _locationDetailsBySlugUri = '/data/locations/v3/bySlugName';
const _locationDetailsBySlugCacheKey = 'locationDetailsBySlug';

const _getLocationDetailsByPostalCodeUri = '/data/locations/v3/GetCitiesByPostalCode';
const _getLocationDetailsByPostalCodeCacheKey = 'wbLocSearchByPostalCode';

const _getLocationDetailsByCityIdUri = '/data/locations/v3/CityByCityId';
const _getLocationDetailsByCityIdCacheKey = 'wbLocByCityId';

export class LocationDetailsProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_locationDetailsCacheKey] = this.locationDetailsSyncer.bind(this);
        this.storage.sync[_locationDetailsBySlugCacheKey] = this.locationDetailsBySlugSyncer.bind(this);
        this.storage.sync[_getLocationDetailsByPostalCodeCacheKey] = this.locationDetailsByPostalCodeSyncer.bind(this);
        this.storage.sync[_getLocationDetailsByCityIdCacheKey] = this.locationDetailsByCityIdSyncer.bind(this);
    }

    async locationDetailsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            locationtype: 'latitudelongitude',
            location: `${syncParams.latitude},${syncParams.longitude}`,
            verbose: syncParams.verbose
        };

        const responseValidator = response => {
            return !!response;
        };

        return await super.syncData(syncParams.key, id, queryParams, _locationDetailsUri, resolve, reject, responseValidator, syncParams.pulseApi);
    }

    async getLocationDetails(latitude, longitude, stdParameters, verbose, refresh = false) {
        const syncParams = {
            latitude,
            longitude,
            verbose: !!verbose,
            refresh
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_locationDetailsCacheKey, id);
        }
        return await super.loadFromStorage(_locationDetailsCacheKey, id, syncParams);
    }

    async locationDetailsBySlugSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            slugname: syncParams.slugname,
            verbose: syncParams.verbose
        };

        const responseValidator = response => {
            return !!response;
        };

        return await super.syncData(syncParams.key, id, queryParams, _locationDetailsBySlugUri, resolve, reject, responseValidator, syncParams.pulseApi);
    }

    async getLocationDetailsBySlugName(slugname, stdParameters, verbose, refresh = false) {
        const syncParams = {
            slugname,
            verbose: !!verbose,
            refresh
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_locationDetailsBySlugCacheKey, id);
        }
        return await super.loadFromStorage(_locationDetailsBySlugCacheKey, id, syncParams);
    }

    async locationDetailsByPostalCodeSyncer(params) {
        const {
            id
            , syncParams
            , resolve
            , reject
        } = params;


        const queryParams = {
            ...syncParams.stdParameters
            , postalCode: syncParams.postalCode
            , countryCode: syncParams.countryCode
            , verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getLocationDetailsByPostalCodeUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , null);
    }

    async getLocationDetailsByPostalCode(postalCode, countryCode, stdParameters, verbose, refresh = false) {
        const syncParams = {
            verbose: !!verbose
            , postalCode
            , countryCode
            , refresh
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getLocationDetailsByPostalCodeCacheKey, id);
        }
        return await super.loadFromStorage(_getLocationDetailsByPostalCodeCacheKey, id, syncParams);
    }

    async locationDetailsByCityIdSyncer(params) {
        const {
            id
            , syncParams
            , resolve
            , reject
        } = params;


        const queryParams = {
            ...syncParams.stdParameters
            , cityId: syncParams.cityId
            , verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getLocationDetailsByCityIdUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , null);
    }

    async getLocationDetailsByCityId(cityId, stdParameters, verbose, refresh = false) {
        const syncParams = {
            verbose: !!verbose
            , cityId
            , refresh
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getLocationDetailsByCityIdCacheKey, id);
        }
        return await super.loadFromStorage(_getLocationDetailsByCityIdCacheKey, id, syncParams);
    }
}
